"use client"
import LocationButton from "@/components/framework/locationswitcher/LocationButton";
import { LocationContext } from "@/components/framework/locationswitcher/locationReducer";
import classNames from "classnames";
import { use } from "react";
import styles from "./SelectedLocationDisplay.module.css";


//#region [Component]
export default function SelectedLocationsDisplay() {
    const locationState = use(LocationContext);

    const clickHandler = () => {
        if (!locationState.isShowingLocationTools) {
            locationState.dispatcher({ type: "toggleToolsDisplay", value: true })
        }
    }

    return <div className={classNames(styles.SelectedLocationDisplay, locationState.selected.length === 0 ? styles.Hidden : undefined)}>
        <button className={styles.Label} onClick={clickHandler}>Mine bygdekinoer:</button>
        {locationState.selected.map(th => <LocationButton key={th.teaternr} location={th} onClick={clickHandler} icon="checkmark"/>)}
    </div>;
}
//#endregion